import { JSONRPCError, UnknownBlockError } from '../errors';
export class JSONRPCProvider {
    constructor() {
        this.handleResponse = (responseJSON) => {
            if (responseJSON.error !== undefined) {
                if (responseJSON.error.code === -100 && responseJSON.error.message === 'Unknown block') {
                    throw new UnknownBlockError();
                }
                throw new JSONRPCError(responseJSON.error);
            }
            return responseJSON.result;
        };
    }
}

//# sourceMappingURL=JSONRPCProvider.js.map
